import { useEffect, useRef, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getVideo } from '../../../../s3Func/s3Download';
import MediaService from '../../../../services/MediaService';

import countdown1 from '../assets/image/Countdown-1_2x.png';
import countdown2 from '../assets/image/Countdown-2_2x.png';
import countdown3 from '../assets/image/Countdown-3_2x.png';
import countdownSound from '../assets/audio/count_down_beep.m4a';

import Popup from '../../../../Popup/logoutPopup';
import CancelRecordPopup from './popup/CancelRecordPopup';

import './SingingRecord.scss';
import { ReactMic } from 'react-mic';

const SingingRecord = ({ video, audio, onRecordEnd, onCancelRecord}) => {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const recordIcon = MediaService.getImage(
    '/Module1Images/Record-Small_3x.png',
    login
  );

  const [cancelMessage, setCancelMessage] = useState(null);
  const [videoSrc, setVideoSrc] = useState(getVideo(video, login));

  const [countDown, setCountDown] = useState(null);
  const countdownList = [countdown1, countdown1, countdown2, countdown3];

  const cdSound = new Audio(countdownSound);

  const videoPlayer = useRef();
  const recordBtn = useRef();
  const startRecordBtn = useRef();
  const endRecordBtn = useRef();

  const [recording, setRecording] = useState(false);
  const [recordurl, setRecordUrl] = useState(null);

  useEffect(() => {
    if(recordurl)
    {
      if(cancelMessage){
        setCancelMessage(false);
        onCancelRecord();
      }
      else{
        onRecordEnd(recordurl);
      }
    }
  }, [recordurl]);

  const showCountdownAndRecord = () => {
    let secondsRemaining = 3;

    const countdownInterval = setInterval(async () => {
      setCountDown(secondsRemaining);

      if (secondsRemaining > 0) cdSound.play();

      secondsRemaining--;

      if (secondsRemaining <= -1) {
        setCountDown(null);
        clearInterval(countdownInterval);
        videoPlayer.current.play();
        startRecordBtn.current.click();
        recordBtn.current.style.opacity = '0.9';
      }
    }, 1000);
  };

  const pauseVideoAndEndRecording = () => {
    videoPlayer.current.pause();
    endRecordBtn.current.click();
  };

  const handleContinueRecording = () => {
    setCancelMessage(false);
  };

  const onRecordClick = () => {
    setCancelMessage(true);
  };

  return (
    <>
      {cancelMessage && (
        <Popup
          content={
            <CancelRecordPopup
              onCancelRecording={() => {
                endRecordBtn.current.click();
              }}
              onContinueRecording={handleContinueRecording}
            />
          }
        />
      )}
      <img className='record-countdown' alt='' src={countdownList[countDown]} />
      {videoSrc && (
        <video
          ref={videoPlayer}
          className='record-video'
          onEnded={() => pauseVideoAndEndRecording()}
          onError={() => pauseVideoAndEndRecording()}
          onLoadedData={() => showCountdownAndRecord()}
          playsInline
        >
          <source src={videoSrc} type='video/mp4'></source>
          Your browser does not support the video tag.
        </video>
      )}
      <button className='record-button' onClick={onRecordClick} ref={recordBtn}>
        <img src={recordIcon} alt='record btn' />
      </button>
      <ReactMic
        className={'micRecording'}
        record={recording}
        onStop={(recordedBlob) => {
          setRecordUrl(recordedBlob.blobURL);
        }} />
      <button onClick={()=>{setRecording(true)}} ref={startRecordBtn} type="button" style={{ opacity: 0}}>Start</button>
      <button onClick={()=>{setRecording(false)}} ref={endRecordBtn} type="button" style={{ opacity: 0}}>Stop</button>
    </>
  );
};

export default SingingRecord;
